module.exports = __webpack_public_path__ + "static/media/COMP-BNB.b628e3a6.svg";